import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends, assertThisInitialized as _assertThisInitialized } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NavLinkContext from './NavLinkContext.js';

var _excluded = ["children"];
var NavLinkGroup = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NavLinkGroup, _Component);
  function NavLinkGroup(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.navLinkContext = function (state) {
      return {
        isActive: function isActive(linkToCheck) {
          return linkToCheck == state.active;
        },
        // in case we want to add the active class to things that contain subpages that include the active page
        containsActive: function containsActive(linkToCheck) {
          return linkToCheck.includes(state.active);
        },
        setActive: function setActive(link, event) {
          return _this.handleActiveUpdate(link, event);
        }
      };
    };
    _this.handleActiveUpdate = function (activeLink, event) {
      var active = _this.state.active == activeLink;
      if (!active) {
        _this.setState({
          active: activeLink
        }, _this.props.onChange(activeLink, event));
      } else {
        _this.setState({
          active: null
        }, _this.props.onChange(null, event));
      }
    };
    _this.handleActiveUpdate = _this.handleActiveUpdate.bind(_assertThisInitialized(_this));
    _this.navLinkContext = _this.navLinkContext.bind(_assertThisInitialized(_this));
    _this.state = {
      active: props.active || null
    };
    return _this;
  }
  var _proto = NavLinkGroup.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      args = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/React.createElement(NavLinkContext.Provider, _extends({
      value: this.navLinkContext(this.state)
    }, args), children);
  };
  return NavLinkGroup;
}(Component);
NavLinkGroup.propTypes = {
  /**
   * The active value
   */
  active: PropTypes.string,
  children: PropTypes.node,
  onChange: PropTypes.func
};

export { NavLinkGroup as default };
//# sourceMappingURL=NavLinkGroup.js.map
